module.exports = __webpack_public_path__ + "static/media/terminal-outline.0bbd9ed6.svg";